const ButtonVariants = {
  DEFAULT: "default",
  OUTLINED: "outlined",
  LINK: "link",
};

export default ButtonVariants;
